import React from 'react';
import PropTypes from 'prop-types';
import './InfoPill.css';

const InfoPill = ({ label, value, backgroundColor, color, className, style }) => (
  <div className={`info-pill-container ${className}`} style={style}>
    <div className="info-pill info-pill-text" style={{ backgroundColor, color }}>
      {label}
    </div>
    <div className="info-pill info-pill-value" style={{ backgroundColor, color }}>
      {value || '---'}
    </div>
  </div>
);

InfoPill.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

InfoPill.defaultProps = {
  value: '---',
  backgroundColor: '',
  color: 'currentcolor',
  className: '',
  style: {},
};

export default InfoPill;
